export default "__VITE_ASSET__D81aq6yT__"